/**
 * Circuit IR / DRC / snapshot / lineage / import-diff query keys. Mirrors
 * the `/circuits/...` router. Snapshot IDs are globally unique (UUIDs),
 * so no scope wrapper is needed.
 */
export const circuitKeys = {
  all: ["circuits"] as const,
  versionIr: (versionId: string) =>
    [...circuitKeys.all, "version", versionId, "ir"] as const,
  versionDrc: (versionId: string, severity?: string) =>
    [
      ...circuitKeys.all,
      "version",
      versionId,
      "drc",
      severity ?? "all",
    ] as const,
  importDiff: (fromVersionId: string, toVersionId: string) =>
    [...circuitKeys.all, "diff", fromVersionId, toVersionId] as const,
  snapshot: (snapshotId: string) =>
    [...circuitKeys.all, "snapshot", snapshotId] as const,
  snapshotDrc: (snapshotId: string, severity?: string) =>
    [
      ...circuitKeys.all,
      "snapshot",
      snapshotId,
      "drc",
      severity ?? "all",
    ] as const,
  snapshotLineage: (snapshotId: string) =>
    [...circuitKeys.all, "snapshot", snapshotId, "lineage"] as const,
  /** All circuits in a project, optionally filtered by status. */
  byProject: (projectId: string, status?: string[]) =>
    [
      ...circuitKeys.all,
      "byProject",
      projectId,
      status?.join(",") ?? "all",
    ] as const,
  /** A single Circuit's full DTO. */
  detail: (circuitId: string) =>
    [...circuitKeys.all, "circuit", circuitId] as const,
  /** Newest-first version chain for a single Circuit. */
  versions: (circuitId: string) =>
    [...circuitKeys.all, "circuit", circuitId, "versions"] as const,
  /** Oldest-first parent_circuit_id chain (root → input) for a Circuit. */
  lineage: (circuitId: string) =>
    [...circuitKeys.all, "circuit", circuitId, "lineage"] as const,
  /** PCB overlay (placements + tracks + layers) for a version. */
  pcbOverlay: (versionId: string) =>
    [...circuitKeys.all, "version", versionId, "pcb-overlay"] as const,
  /** Board annotations for a version — AI co-pilot's read of the board. */
  annotations: (versionId: string) =>
    [...circuitKeys.all, "version", versionId, "annotations"] as const,
};
